@let isSm = viewportSelectors.isSm | select;
<div class="flex flex-col items-center md:shrink-0">
  @if (!forLookupContext && isSm) {
    <div class="max-w-[18.75rem] relative overflow-hidden">
      <img ngSrc="/assets/registration/create-account-sm.png" fill priority alt="" class="relative flex w-full h-auto"/>
    </div>
  }
  <mat-card class="max-w-[25rem]">
    <mat-card-content class="flex flex-col gap-y-3">
      @if (forLookupContext) {
        <div class="text-headline-large">Enter Your Email</div>
        <div class="text-body-large mb-8">Please provide your email address. This will be used as your username.</div>
      } @else {
        <div class="text-headline-large">Create Account</div>
        <div class="text-body-large mb-8">Please provide your email address. An email address is required to use many of
          our digital resources, such as e-books.
          If you do not wish to provide an email address, you can apply for a physical card in person at your local
          branch.
        </div>
      }

      <mx-input-form-field fieldName="email" [formGroup]="emailForm"/>

      <mx-filled-button label="Submit" [enabled]="emailForm.valid" (click)="onClickNext()"/>
      @if (!forLookupContext) {
        <div>Already have an account? <mx-link-button label="Login here" linkType="inline" routeName="INDEX" class="ml-1"/></div>
      }
    </mat-card-content>
  </mat-card>
</div>

@if (!isSm) {
  <div class="relative overflow-hidden flex flex-row items-center w-[50%] max-w-[21rem] lg:max-w-[29.5rem] lg:h-[30rem]">
    @let imageSrc = forLookupContext ? '/assets/registration/verify-email.png' : '/assets/registration/create-account.png';
    <img [ngSrc]="imageSrc" fill priority alt="" class="relative flex w-full h-auto"/>
  </div>
}
